'use client';
import { ClientOnlyLoader } from '../ClientOnlyLoader';
import { ToggleFavouriteProps } from './ToggleFavoriteClient';
import { Skeleton } from '@/components/ui/skeleton';

const toggleFavoriteLoader = () => import('./ToggleFavoriteClient');

export function ToggleFavourite(props: ToggleFavouriteProps) {
  return (
    <ClientOnlyLoader load={toggleFavoriteLoader} fallback={<Skeleton className='w-[24px] h-[24px]' />} props={props} />
  );
}
